import Vue from 'vue'
import {
  ConfigProvider,
  Button,
  Icon,
  DatePicker,
  Collapse,
  Checkbox,
  Modal,
  Spin,
  Table,
  Empty,
  Divider,
  Descriptions,
  Timeline,
  Dropdown,
  Menu,
  Breadcrumb,
  Switch,
  Carousel
} from 'ant-design-vue'

Vue.use(ConfigProvider)
  .use(Button)
  .use(Icon)
  .use(DatePicker)
  .use(Collapse)
  .use(Checkbox)
  .use(Modal)
  .use(Spin)
  .use(Table)
  .use(Empty)
  .use(Divider)
  .use(Descriptions)
  .use(Timeline)
  .use(Dropdown)
  .use(Menu)
  .use(Breadcrumb)
  .use(Switch)
  .use(Carousel)

Vue.prototype.$antConfirm = Modal.confirm
